export default __webpack_public_path__ + "./assets/img/reasons-3-3b6ff37bc0c8b095bee998df94c66dd5.png";